

export const listLinks = [{name: "Skills", to: "/skills"}, {name: "Hello", to: "/hello"}, {name: "Work", to: "/work"}, {name: "Contact", to: "?form=contact"}]

export const listIcons = [{img: "/icons/linkedin.svg", to: "https://www.linkedin.com/in/den-yakovenko/"}, {img: "/icons/github.svg", to: "https://github.com/den4k-pr"}, {img: "/icons/telegram.svg", to: "https://t.me/DenShkkl"}]
